import { render } from "./DraggableColumn.vue?vue&type=template&id=3c348fb8"
import script from "./DraggableColumn.vue?vue&type=script&lang=js"
export * from "./DraggableColumn.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.9.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__